import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import moment from "moment-business-days";

import "Models/ConstructionSiteCard";

import followUpComponent from "../../components/followUp/followUpComponent";
import { tableSorterComponent } from "../../_shark_components/tableSorter/tableSorterComponent";

class ConstructionSiteCardManager extends Controller {
	constructor () {
		super("constructionSiteCardManager");
		this.remoteClassName = "construction-site-card";
	}

	checkCommunicateStarting (constructionSiteCard) {
		const today = moment().format(Shark.get("dateISOFormat"));
		const futureDay = moment().businessAdd(5).format(Shark.get("dateISOFormat"));
		const cscStartDate = constructionSiteCard.__startDate;
		
		console.log({today,futureDay,cscStartDate});

		if (cscStartDate >= today && cscStartDate <= futureDay) {
			this.communicateStarting(constructionSiteCard.guid);
		}
	}
	
	async checkFolders (guid) {
		const rd = NousCore.api.createRequest({ item: { createOnMissing: true, guid } });
		const requestedAction = "check-folders";


		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	communicateStarting (constructionSiteCardGuid) {
		const rd = NousCore.api.createRequest({ item: { guid: constructionSiteCardGuid } });
		const action = "communicate-starting";
	
		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction: action,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	delete (item, deleteReason, regressQuotationStatus) {
		const rd = NousCore.api.createRequest({ item: { guid: item.guid, deleteReason, regressQuotationStatus }});
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getByCCA (cca) {
		const rd = NousCore.api.createRequest({ item: { cca } });
		const action = "get-by-cca";
	
		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", data.items);
	
						return {
							data: constructionSiteCardList,
							requestedAction: action,
							status: "ok"
						};
					}
					case 404:
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	getByGuid (guid, constructionSiteCardToFill = null) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const action = "get-by-guid";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							if (constructionSiteCardToFill) {
								constructionSiteCardToFill.import(data.items[0]);
								constructionSiteCardToFill.clean();
							}
							else {
								constructionSiteCardToFill = Shark.getInstance("ConstructionSiteCard", data.items[0]);
							}
	
							return {
								data: constructionSiteCardToFill,
								requestedAction: action,
								status: "ok",
							};
						}
						else {
							return {
								data: null,
								requestedAction: action,
								status: "ko",
							};
						}
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", data.items);
						const constructionSiteCardGroupsMap = {};
												
						if (incrementalRequest) {
							constructionSiteCardList = [...Shark.get("constructionSiteCardList"), ...constructionSiteCardList];
						}

						// constructionSiteCardList.sort((a, b) => {
						// 	if (a.lotReferenceGuid > b.lotReferenceGuid) {
						// 		return -1;
						// 	}
						// 	else if (a.lotReferenceGuid < b.lotReferenceGuid) {
						// 		return 1;
						// 	}
						// });
	
						constructionSiteCardList.forEach(item => {
							if (constructionSiteCardGroupsMap[item.lotReferenceGuid]) {
								constructionSiteCardGroupsMap[item.lotReferenceGuid].push(item);
							}
							else {
								constructionSiteCardGroupsMap[item.lotReferenceGuid] = [item];
							}
						});
	
						const constructionSiteCardGroupList = Object.values(constructionSiteCardGroupsMap);
	
						constructionSiteCardGroupList.forEach(group => {
							group.sort((a, b) => {
								if (a.updatedAt > b.updatedAt) {
									return -1;
								}
								else if (a.updatedAt < b.updatedAt) {
									return 1;
								}
							});
	
							// group[0].__groupCSSClass = "firstOfGroup";
							
							// if (group.length > 1) {
							// 	group[group.length - 1].__groupCSSClass = "lastOfGroup";
							// }
						});

						let counter = 1;
						constructionSiteCardGroupList.forEach((group) => {
							group.forEach((item) => {
								item.__displayIndex = (counter++);
							});
						});
	
						constructionSiteCardList.sort((a, b) => {
							if (a.updatedAt < b.updatedAt) {
								return 1;
							}
							else if (a.updatedAt > b.updatedAt) {
								return -1;
							}
						});
						
						Shark.set({
							constructionSiteCardList,
							constructionSiteCardGroupList,
							__constructionSiteCardListNeedFurtherLoad: data.availableItemCount > constructionSiteCardList.length,
							__availableFurtherItems: data.availableItemCount - constructionSiteCardList.length,
						});
						// console.log({
						// 	constructionSiteCardList,
						// 	constructionSiteCardGroupList,
						// 	__constructionSiteCardListNeedFurtherLoad: data.availableItemCount > constructionSiteCardList.length,
						// 	__availableFurtherItems: data.availableItemCount - constructionSiteCardList.length,
						// })

						return {
							data: constructionSiteCardList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}




		
	getByQuotation (quotation) {
		const rd = NousCore.api.createRequest({ item: quotation.export() });

		return NousCore.api.send("construction-site-card/get-by-quotation", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", data.items);

						return {
							data: constructionSiteCardList,
							requestedAction: "get-by-quotation",
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							requestedAction: "get-by-quotation",
							status: "ko"
						};
				}
			}
		});
	}

	getList () {
		const rd = NousCore.api.createRequest();

		return NousCore.api.send("construction-site-card/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", data.items);
						const constructionSiteCardGroupsMap = {};
						
						constructionSiteCardList.sort((a, b) => {
							if (a.lotReferenceGuid > b.lotReferenceGuid) {
								return -1;
							}
							else if (a.lotReferenceGuid < b.lotReferenceGuid) {
								return 1;
							}
						});

						constructionSiteCardList.forEach(item => {
							if (constructionSiteCardGroupsMap[item.lotReferenceGuid]) {
								constructionSiteCardGroupsMap[item.lotReferenceGuid].push(item);
							}
							else {
								constructionSiteCardGroupsMap[item.lotReferenceGuid] = [item];
							}
						});

						const constructionSiteCardGroupList = Object.values(constructionSiteCardGroupsMap);

						constructionSiteCardGroupList.forEach(group => {
							group.sort((a, b) => {
								if (a.startDate > b.startDate) {
									return -1;
								}
								else if (a.startDate < b.startDate) {
									return 1;
								}
							});

							group[0].__groupCSSClass = "firstOfGroup";
							
							if (group.length > 1) {
								group[group.length - 1].__groupCSSClass = "lastOfGroup";
							}
						});

						constructionSiteCardList.sort((a, b) => {
							if (a.updatedAt < b.updatedAt) {
								return 1;
							}
							else if (a.updatedAt > b.updatedAt) {
								return -1;
							}
						});
						
						Shark.set({
							constructionSiteCardList,
							constructionSiteCardGroupList,
							// latestConstructionSiteCardList: constructionSiteCardList.slice(0, 6)
						});

						constructionSiteCardManager.emit("listChanged");
						return {
							data: constructionSiteCardList,
							requestedAction: "get-list",
							status: "ok"
						};
					}
					case 404:
						constructionSiteCardManager.emit("listGetError");
						return {
							data: null,
							requestedAction: "get-list",
							status: "ko"
						};
				}
			}
		});
	}

	getListByAgent (user) {
		const rd = NousCore.api.createRequest({ item: { userGuid: user.guid } });

		NousCore.api.send("construction-site-card/get-list-by-agent", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const constructionSiteCardList = Shark.getInstanceList("ConstructionSiteCard", data.items);

						// constructionSiteCardList.sort((a, b) => {
						// 	if (a.startDate < b.startDate) {
						// 		return 1;
						// 	}
						// 	else if (a.startDate > b.startDate) {
						// 		return -1;
						// 	}
						// });
						
						tableSorterComponent.set({
							tableContentList: constructionSiteCardList
						});

						followUpComponent.set({
							sourceList: constructionSiteCardList
						});
						
						Shark.set({
							constructionSiteCardList: constructionSiteCardList,
							latestConstructionSiteCardList: constructionSiteCardList.slice(0, 6)
						});

						constructionSiteCardManager.emit("listChanged");
						break;
					}
					case 404:
						constructionSiteCardManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getListByAgentAndClient (userGuid, clientGuid) {
		const rd = NousCore.api.createRequest({ item: { userGuid: userGuid, clientGuid: clientGuid } });

		NousCore.api.send("construction-site-card/get-list-by-agent-and-client", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const siteInfoSheetList = Shark.getInstanceList("SiteInfoSheet", data.items);

						siteInfoSheetList.sort((a, b) => {
							if (a.referenceDate > b.referenceDate) {
								return 1;
							}
							else if (a.referenceDate < b.referenceDate) {
								return -1;
							}
						});

						Shark.set("siteInfoSheetList", siteInfoSheetList);

						constructionSiteCardManager.emit("listChanged");
						break;
					}
					case 404:
						constructionSiteCardManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (constructionSiteCard) {
		const rd = NousCore.api.createRequest({ item: constructionSiteCard.export() });
		const action = constructionSiteCard.guid === "" ? "insert" : "update";

		return NousCore.api.send(`construction-site-card/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						constructionSiteCard.import(data.items[0]);
						constructionSiteCard.clean();

						const constructionSiteCardList = Shark.get("constructionSiteCardList");
						if (constructionSiteCardList) {
							const constructionSiteCardIndex = Utils.safp(constructionSiteCardList, "guid", constructionSiteCard.guid, "index");

							if (constructionSiteCardIndex > -1) {
								constructionSiteCardList[constructionSiteCardIndex] = constructionSiteCard;
							}
						}

						constructionSiteCardManager.emit("saved");
						return {
							data: constructionSiteCard,
							status: "ok"
						};
					}
					case 99:
						constructionSiteCardManager.emit("saveError");
						return {
							data: null,
							status: "ko"
						};
				}
			}
		});
	}
}

const constructionSiteCardManager = new ConstructionSiteCardManager();

Shark.registerController(constructionSiteCardManager);

export { constructionSiteCardManager };
